import Service from "../../AuthService";
import {domain} from "../../../util/Constants";
const OverviewSale = {
    //for seller order
    getPerDay(start_date , end_date , sale_id,type){
        return Service.get("/sale_per_day?"+
            "sale_id="+sale_id+
            "&start_date="+start_date+
            "&end_date="+end_date+
            "&type="+type
        )
    },
    //report sale
    downloadCommissionSale(sale_id,start_date,end_date,type){
        return Service.get(`/invoices/report_commission_sale?sale_id=${sale_id}&start_date=${start_date}&end_date=${end_date}&type=${type}`);
    },
    //report sale
    downloadCommissionSaleType(sale_id,start_date,end_date,product_type){
        return Service.get(`/invoices/report_commission_sale_type?sale_id=${sale_id}&start_date=${start_date}&end_date=${end_date}&type=${product_type}`);
    },
    downloadPromotionSale(sale_id,start_date,end_date){
        return Service.get(`/invoices/report_promotion_sale?sale_id=${sale_id}&start_date=${start_date}&end_date=${end_date}`);
    },
    downloadRvSaleReport(sale_id,start_date,end_date){
        return Service.get(`/invoices/report_rv_sale?sale_id=${sale_id}&start_date=${start_date}&end_date=${end_date}`);
    },
    downloadCnSaleReport(sale_id,start_date,end_date){
        return Service.get(`/invoices/report_cn_sale?sale_id=${sale_id}&start_date=${start_date}&end_date=${end_date}`);
    },
    downloadCustomerSaleReport(sale_id,month_start,month_end){
        return Service.get(`/invoices/report_customer_per_year?sale_id=${sale_id}&month_start=${month_start}&month_end=${month_end}`);
    },
    downloadProductSaleReport(date){
        return Service.get(`/invoices/report_product_sale?date=${date}`);
    },
};
export default OverviewSale;
